<template>
    <div class="english-container">
  
      <h1>Schnellstart</h1>
  
      <h2>Android:</h2>
  
      <ol>
        <li>
          Schalten Sie die Smart Card ein.
          Warten Sie, bis das Pop-up erscheint.
          Falls kein Pop-up angezeigt wird,
          folgen Sie bitte den untenstehenden Schritten.
        </li>
  
        <li>
          Öffnen Sie die Einstellungen,
          gehen Sie zu „Google“
          und tippen Sie anschließend auf „Alle Dienste“.
        </li>
  
        <li>
          Wählen Sie im Menü
          „Verbundene Geräte & Teilen“
          die Option „Geräte“ aus.
        </li>
  
        <li>
          Aktivieren Sie „Nach Geräten in der Nähe suchen“.
        </li>
  
        <li>
          Die Smart Card erscheint
          in der Liste der verfügbaren Geräte in der Nähe.
        </li>
  
        <li>
          Tippen Sie auf das Gerät
          und folgen Sie den Anweisungen auf dem Bildschirm,
          um die Verbindung abzuschließen.
        </li>
      </ol>
  
      <div class="divider"></div>
  
      <h2>In der Nähe suchen</h2>
  
      <p>
        Öffnen Sie die App „Google Find Hub“,
        wählen Sie Ihre Smart Card aus
        und tippen Sie auf „Ton abspielen“,
        um Ihr Gerät zu orten.
        Sobald das Gerät gefunden wurde,
        tippen Sie auf „Ton stoppen“.
      </p>
  
      <h2>Aus der Ferne suchen</h2>
  
      <p>
        Öffnen Sie die App „Google Find Hub“,
        wählen Sie Ihre Smart Card aus
        und tippen Sie auf das Gerät,
        um den Standort anzuzeigen.
      </p>
  
      <p>
        Um zum Standort zu navigieren,
        tippen Sie auf „Route anzeigen“,
        um die Karten-Navigation zu öffnen.
      </p>
  
      <div class="divider"></div>
  
      <h1>Zurücksetzen</h1>
  
      <ol>
        <li>
          Öffnen Sie die App „Google Find Hub“,
          wählen Sie Ihre Smart Card aus,
          tippen Sie auf die Einstellungen
          und anschließend auf
          „Aus Find Hub entfernen“,
          danach bestätigen Sie den Vorgang.
        </li>
  
        <li>
          Wenn das Gerät eingeschaltet ist,
          drücken Sie die Taste fünfmal hintereinander.
          Halten Sie die Taste beim fünften Drücken gedrückt,
          bis Sie den Signalton hören.
        </li>
      </ol>
  
      <p class="remark">
        Hinweis:
        Bitte schalten Sie die Smart Card ein
        und entfernen Sie das Gerät aus der App
        „Google Find Hub“,
        bevor Sie das Gerät zurücksetzen.
      </p>
  
      <div class="divider"></div>
  
      <h1>Fast Pair Anleitung</h1>
  
      <h2>Smart Card hinzufügen</h2>
  
      <ol>
        <li>
          Stellen Sie sicher,
          dass Bluetooth und die Netzwerkverbindung
          Ihres Telefons aktiviert sind.
        </li>
  
        <li>
          Drücken Sie einmal die Taste,
          um die Smart Card einzuschalten
          (ein Signalton ertönt).
        </li>
  
        <li>
          Halten Sie die Smart Card
          in die Nähe Ihres Android-Geräts
          und warten Sie,
          bis das Pop-up erscheint.
          <br />
          <strong>Hinweis:</strong>
          Falls kein Pop-up erscheint,
          starten Sie bitte Ihr Telefon neu
          und versuchen Sie es erneut.
        </li>
  
        <li>
          Tippen Sie auf „Verbinden“
          und akzeptieren Sie die Hinweise,
          um die Kopplung abzuschließen.
        </li>
  
        <li>
          Wählen Sie in der App
          „Google Find Hub“
          die Option „Smart Card“,
          um Gerätename und Kategorie anzupassen.
        </li>
      </ol>
  
      <div class="divider"></div>
  
      <h1>Verloren-Modus aktivieren</h1>
  
      <p>
        Öffnen Sie die App „Google Find Hub“,
        wählen Sie Ihre Smart Card aus
        und tippen Sie auf „Als verloren markieren“.
      </p>
  
      <p>
        Geben Sie Ihre Kontaktdaten ein,
        damit Sie benachrichtigt werden,
        wenn das Find Hub-Netzwerk
        Ihr Gerät lokalisiert.
      </p>
  
      <h2>Standortfreigabe der Smart Card</h2>
  
      <p>
        Öffnen Sie die App „Google Find Hub“,
        wählen Sie Ihre Smart Card aus
        und tippen Sie anschließend auf „Gerät teilen“.
      </p>
  
      <h2>Mit einem anderen Telefon verbinden</h2>
  
      <p>
        Nachdem der Reset abgeschlossen ist,
        können Sie die Smart Card
        mit einem anderen Android-Telefon verbinden.
      </p>
  
      <div class="divider"></div>
  
      <h1>Laden</h1>
  
      <p>
        Verwenden Sie ein standardmäßiges kabelloses Ladegerät,
        um das Produkt drahtlos aufzuladen.
      </p>
  
      <p>
        Das rote Licht leuchtet während des Ladevorgangs dauerhaft
        und erlischt, sobald das Gerät vollständig geladen ist.
      </p>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'AndroidCardGermanGuide',
  };
  </script>
  
  <style scoped>
  
  .english-container{
    background-color:#ffffff;
    border-radius:8px;
    padding:30px;
    margin:10px auto;
    max-width:1000px;
    box-shadow:0 2px 8px rgba(0,0,0,0.08);
  }
  
  h1{
    font-size:40px;
    margin-top:10px;
    margin-bottom:20px;
    color:#222;
    text-align:left;
  }
  
  h2{
    font-size:24px;
    margin-top:28px;
    margin-bottom:12px;
    color:#333;
    text-align:left;
  }
  
  p{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:14px;
    text-align:left;
  }
  
  ol{
    padding-left:24px;
    margin-bottom:20px;
  }
  
  li{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:10px;
    text-align:left;
  }
  
  strong{
    color:#222;
  }
  
  .remark{
    font-size:14px;
    color:#666;
    background:#f8f8f8;
    padding:12px 14px;
    border-left:4px solid #ff4fa0;
    border-radius:4px;
  }
  
  .divider{
    width:100%;
    height:1px;
    background:#e5e5e5;
    margin:40px 0;
  }
  
  @media (max-width:768px){
  
    .english-container{
      padding:20px;
    }
  
    h1{
      font-size:30px;
    }
  
    h2{
      font-size:20px;
    }
  
    p, li{
      font-size:14px;
    }
  }
  
  </style>